import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@awaze/design-system.components.stack';
import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
import { Text } from './text';
export const TextWithIcon = ({ icon, titleProps, textProps, isMobile = false, }) => {
    const { text: titleText, ...rest } = titleProps;
    const { text: bodyText, ...props } = textProps;
    return (_jsxs(Stack, { direction: "row", spacing: 16, children: [_jsx(IconWrapper, { children: icon }), _jsxs(Stack, { spacing: 0, children: [_jsx(Text, { type: "bold", sizes: isMobile ? 300 : 400, ...rest, children: titleText }), _jsx(Text, { sizes: 300, ...props, children: bodyText })] })] }));
};
const IconWrapper = styled.div `
  margin-top: ${pxToRems(4)};
`;
//# sourceMappingURL=text-with-icon.js.map